"use client";

import { Badge } from "../shadcn/badge";

interface SubscriptionTierProps {
  plan: "Starter" | "Plus" | "Max" | "Ultra";
}

export function SubscriptionTier({ plan }: SubscriptionTierProps) {
  return (
    <div className="space-y-2">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        Current Plan
      </h3>
      <div className="flex items-center justify-between">
        <Badge
          variant={plan === "Starter" ? "secondary" : "default"}
          className={
            plan === "Ultra"
              ? "bg-gradient-to-r from-amber-500 to-orange-600 text-white"
              : plan === "Max"
                ? "bg-gradient-to-r from-violet-500 to-purple-700 text-white"
                : plan === "Plus"
                  ? "bg-gradient-to-r from-blue-500 to-blue-700 text-white"
                  : ""
          }
        >
          {plan}
        </Badge>
      </div>
    </div>
  );
}
